import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import newAPIService from "service/network/newAPIService";

class RiskStratificationService {
  constructor() {
    this.apiService = new APIService();
  }

  fetchDashboard = (body, onResponse, onError) => {
    let url = APIConfig.riskStratification.dashboard;
    return this.apiService.post(url, body, onResponse, onError);
  };

  fetchDashboardStats = (body, onResponse, onError) => {
    let url = APIConfig.riskStratification.dashboardStats;
    return this.apiService.post(url, body, onResponse, onError);
  };

  exportDashboard = (body) => {
    const url = APIConfig.riskStratification.export;
    const headers = {
      "Content-Type": "application/json",
    };
    const auth = newAPIService.headers || {};
    if (auth.client) headers.client = auth.client;
    if (auth.phone_no) headers.phone_no = auth.phone_no;
    if (auth.auth_token) headers.auth_token = auth.auth_token;

    return fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body || {}),
    }).then(async (res) => {
      if (!res.ok) {
        let detail = "";
        try {
          detail = await res.text();
        } catch (_) {}
        throw new Error(detail || `Export failed (${res.status})`);
      }
      const blob = await res.blob();
      const disposition = res.headers.get("Content-Disposition") || "";
      const match = disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : "risk-stratification-export.csv";
      return { blob, filename };
    });
  };

  fetchDetail = (id, onResponse, onError) => {
    let url =
      APIConfig.riskStratification.detail + "/" + id + "?includePrevious=true";
    return this.apiService.get(url, onResponse, onError);
  };

  fetchPatientHistory = (patientId, excludeId, onResponse, onError) => {
    let url = APIConfig.riskStratification.history + "/" + patientId;
    if (excludeId) url += "?excludeId=" + excludeId;
    return this.apiService.get(url, onResponse, onError);
  };

  saveEvaluation = (id, body, onResponse, onError) => {
    let url = APIConfig.riskStratification.detail + "/" + id + "/evaluation";
    return this.apiService.post(url, body, onResponse, onError);
  };

  assignEvaluator = (id, onResponse, onError) => {
    let url = APIConfig.riskStratification.detail + "/" + id + "/assign";
    return this.apiService.post(url, {}, onResponse, onError);
  };

  fetchAudits = (id, onResponse, onError) => {
    let url = APIConfig.riskStratification.detail + "/" + id + "/audits";
    return this.apiService.get(url, onResponse, onError);
  };

  fetchVitalsTrend = (patientId, fromDate, toDate, onResponse, onError) => {
    let url = APIConfig.riskStratification.vitalsTrend
      .replace("{0}", patientId)
      .replace("{1}", fromDate)
      .replace("{2}", toDate);
    return this.apiService.get(url, onResponse, onError);
  };

  fetchLabTestHistory = (patientId, onResponse, onError) => {
    let url = APIConfig.tracking.labtest.getNext.format(patientId, 100, 1);
    return this.apiService.get(url, onResponse, onError);
  };

  fetchPatientDetails = (patientId, onResponse, onError) => {
    let url = APIConfig.patient.get.format(patientId);
    return this.apiService.get(url, onResponse, onError);
  };

  fetchAccountCodes = ({ q = "", offset = 0, limit = 50 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (offset) params.set("offset", String(offset));
    if (limit) params.set("limit", String(limit));
    const qs = params.toString();
    const url =
      APIConfig.riskStratification.accountCodes + (qs ? `?${qs}` : "");
    return new Promise((resolve, reject) => {
      this.apiService.get(url, resolve, reject);
    });
  };

  fetchEvaluators = ({ q = "", offset = 0, limit = 50 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (offset) params.set("offset", String(offset));
    if (limit) params.set("limit", String(limit));
    const qs = params.toString();
    const url =
      APIConfig.riskStratification.evaluators + (qs ? `?${qs}` : "");
    return new Promise((resolve, reject) => {
      this.apiService.get(url, resolve, reject);
    });
  };

  fetchTriggerReasons = ({ q = "", offset = 0, limit = 50 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (offset) params.set("offset", String(offset));
    if (limit) params.set("limit", String(limit));
    const qs = params.toString();
    const url =
      APIConfig.riskStratification.triggerReasons + (qs ? `?${qs}` : "");
    return new Promise((resolve, reject) => {
      this.apiService.get(url, resolve, reject);
    });
  };
}

export default RiskStratificationService;
